import { InputHTMLAttributes, ReactNode } from "react";

import { Container, IconContainer, Input } from "./_inputIconBox";

interface IInputIconBoxProps extends InputHTMLAttributes<HTMLInputElement> {
  icon: ReactNode;
}

export const InputIconBox = ({
  icon,
  className = undefined,
  ...rest
}: IInputIconBoxProps) => {
  return (
    <Container className={className}>
      <IconContainer>
        {icon}
      </IconContainer>
      <Input {...rest} />
    </Container>
  );
}
